import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propStr, propFunc, propShape, propBool, propArrayShape, } from '../../helpers/custom-prop-types';
import { useScrollLock } from '../../helpers/use/useScrollLock';
import HelpComplete from './HelpComplete';
import HelpForm from './HelpForm';
const HelpContent = (props) => {
    const { className, contactType, helpContactCategories, initialValues, isProffitSearchPage, isSucceeded, onCancel, onChangeTab, onClickCall, onClose, onComplete, onSubmit, } = props;
    const ref = useScrollLock();
    const elementProps = useMemo(() => ({
        'data-body-scroll-lock-ignore': '1',
    }), []);
    return (_jsx("div", Object.assign({ className: `help_content_wrapper ${className}`, ref: ref }, { children: _jsx("div", Object.assign({ className: 'help_content' }, { children: _jsxs("div", Object.assign({ className: 'help_content_inner' }, { children: [_jsxs("div", Object.assign({ className: 'help_content_inner_header' }, { children: [!isSucceeded && (_jsx("h4", Object.assign({ className: 'help_content_title' }, { children: "\u4F55\u306B\u304A\u56F0\u308A\u3067\u3059\u304B\uFF1F" }))), _jsxs("div", Object.assign({ className: 'help_content_toggle' }, { children: [_jsx("button", Object.assign({ className: 'help_content_toggle_close', onClick: onClose, type: 'button' }, { children: _jsx("i", Object.assign({ className: 'material-icons hov-icon md-32' }, { children: "remove" })) })), _jsx("button", Object.assign({ className: 'help_content_toggle_cancel', onClick: onCancel, type: 'button' }, { children: _jsx("i", Object.assign({ className: 'material-icons hov-icon md-32' }, { children: "close" })) }))] }))] })), isSucceeded ? (_jsx(HelpComplete, { elementProps: elementProps, onComplete: onComplete })) : (_jsx(HelpForm, { contactType: contactType, elementProps: elementProps, helpContactCategories: helpContactCategories, initialValues: initialValues, isProffitSearchPage: isProffitSearchPage, onCancel: onCancel, onChangeTab: onChangeTab, onClickCall: onClickCall, onSubmit: onSubmit }))] })) })) })));
};
HelpContent.propTypes = {
    className: propStr(),
    contactType: propStr().isRequired,
    helpContactCategories: propArrayShape().isRequired,
    initialValues: propShape().isRequired,
    isProffitSearchPage: propBool().isRequired,
    isSucceeded: propBool().isRequired,
    onCancel: propFunc().isRequired,
    onChangeTab: propFunc().isRequired,
    onClickCall: propFunc().isRequired,
    onClose: propFunc().isRequired,
    onComplete: propFunc().isRequired,
    onSubmit: propFunc().isRequired,
};
HelpContent.defaultProps = {
    className: '',
};
export default HelpContent;
